import { useState } from "react";

import { useTranslation } from "react-i18next";
import styled from "styled-components";

import type { UserCourseLesson } from "api/schemas/UserCourse";
import { CloseIcon } from "assets";
import { IconButton } from "shared/atoms/IconButton";

import { LessonLibraryList } from "./LessonLibraryList";
import { OuterMargin, SmallPrimaryButton, TopBar, TopLeft, TopRight } from "./SharedStyledComponents";

export const LessonPicker = ({
  onClose,
  onAddLessons,
  initialSelectedIds = [],
}: {
  onAddLessons: (lessons: UserCourseLesson[]) => void;
  onClose: () => void;
  initialSelectedIds?: number[];
}) => {
  const { t } = useTranslation();
  const [selectedLessons, setSelectedLessons] = useState<UserCourseLesson[]>([]);

  return (
    <>
      <Root>
        <HeaderRow>
          <OuterMargin>
            <div style={{ padding: "0px 32px" }}>
              <TopBar>
                <TopLeft>
                  <Title>{t("usercourse.add_lesson")}</Title>
                </TopLeft>
                <TopRight>
                  <SmallPrimaryButton
                    onClick={() => {
                      onAddLessons(selectedLessons);
                    }}
                  >
                    {t("buttons.add")}
                  </SmallPrimaryButton>
                  <IconButton
                    label=""
                    onClick={() => {
                      onClose();
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </TopRight>
              </TopBar>
            </div>
          </OuterMargin>
        </HeaderRow>
        <OuterMargin>
          <div style={{ padding: "0px 32px" }}>
            <LessonLibraryList
              multiSelect
              onSelectedLessonsChange={lessons => {
                setSelectedLessons(lessons);
              }}
              initialSelectedIds={initialSelectedIds}
            />
          </div>
        </OuterMargin>
      </Root>
    </>
  );
};

const Title = styled.span`
  font-size: 22px;
  font-weight: 600;
`;

const HeaderRow = styled.div`
  background-color: #fff;
  padding: 16px 0 12px 0;
  margin-bottom: 20px;
`;

const Root = styled.div`
  background-color: #f8f8f8;
`;
